<section class="important-notice-overlay" *ngIf="showImportantNotice">
  <div class="important-notice-modal" role="dialog" aria-modal="true" aria-labelledby="important-notice-title">
    <h2 id="important-notice-title">Dear UDID Card Holders</h2>


    <p>
      To avail Government benefits and services, please provide your consent for sharing UDID data with concerned
      Government agencies by logging in to your PwD Dashboard. Consent can be withdrawn at any time through the PwD
      Dashboard.
    </p>


    <p>
      Regards,<br />
      <strong>UDID Team</strong>
      DEPwD.
    </p>



    <button type="button" class="important-notice-close" (click)="closeImportantNotice()">
      OK
    </button>
  </div>
</section>

<section class="banner-section">
  <div id="homeBanner" class="homeBanner">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <!-- New Slide -->
        <div class="swiper-slide">
          <div class="homeBannerImgWrap appBanner">
            <div class="container">
              <div class="row">
                <div class="col-lg-4">
                  <div class="bannerCaptions">
                    <h2>{{'Now you can Download UDID App' | translate}}</h2>
                    <ul>
                      <li>{{'Update Name' | translate}}</li>
                      <li>{{'Update Aadhaar Number' | translate}}</li>
                      <li>{{'Update Date of Birth' | translate}}</li>
                      <li>{{'Update Mobile Number' | translate}}</li>
                      <li>{{'Update Email ID' | translate}}</li>
                      <li>{{'Surrender Card' | translate}}</li>
                      <li>{{'Lost Card/Card Not Received' | translate}}</li>
                      <li>{{'Download Application' | translate}}</li>
                      <li>{{'Download Receipt' | translate}}</li>
                      <li>{{'Download your E-Disability Certificate' | translate}}</li>
                      <li>{{'Download your E-UDID Card' | translate}}</li>
                      <li>{{"Doctor's Diagnosis Sheet" | translate}}</li>
                    </ul>
                    <div class="downloadBox">
                      <div class="d-flex gap-3 mt-lg-5 mt-3 align-items-center">
                        <p class="mb-0">{{'Download From Here:' | translate}}</p>
                        <a href="https://play.google.com/store/apps/details?id=com.swavlambancard.udid&hl=en_IN"
                          title="Play Store" target="_blank"><img src="assets/images/play-store.svg"
                            alt="Play Store"></a>
                        <!-- <a href="#" target="_blank"><img src="assets/images/app-store.svg" alt="App Store"></a> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8">
                  <div class="bannerImg">
                    <img src="assets/images/app-banner.png" alt="App Banner" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- New Slide End -->
        <ng-container *ngFor="let item of banners ;let i = index">
          <div class="swiper-slide">
            <div class="homeBannerImgWrap">
              <div class="container">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="bannerCaptions">
                      <h2>{{'Unique disability id (UDID)' | translate}}</h2>
                      <a routerLink="/Applyforudid" class="know-more">{{"apply now" |translate}}
                        <!-- <span class="fa-solid fa-chevron-right"></span> --></a>
                      <a routerLink="/track-your-application" class="know-more">{{"Track Your Application" |translate}}
                        <!-- <span class="fa-solid fa-chevron-right"></span>--> </a>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <div class="bannerImg"> <img src="{{BannersPath}}{{item.banner_image}}"
                        alt="{{item.category_image}}" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="paginationWrap">
      <div class="container">
        <div class="paginationWrap">
          <div class="sliderPrev slider__button-prev" title="Previous" tabindex="0" role="button"
            aria-label="Previous slide" aria-disabled="false"> <span class="fa-solid fa-chevron-left"></span> </div>
          <div class="sliderNext slider__button-next swiper-button-disabled" title="Next" tabindex="0" role="button"
            aria-label="Next slide" aria-disabled="true"> <span class="fa-solid fa-chevron-right"></span> </div>
          <div class="swiper-button-play" title="play"><a href="javascript:void(0)" title="play">play</a></div>
          <div class="swiper-button-pause" title="stop"><a href="javascript:void(0)" title="stop">stop</a></div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="noteSection" id="skipContent">
  <div class="marqueeContainer">
    <div class="container-xl">
      <div class="marqueeScrollingWrap">
 
        <div class="marqueeScrolling cf"> <a class="btnMPause alignRight" href=""> <i
              class="fa-regular fa-circle-pause"><span class="d-none">circle-pause</span></i> </a>
          <ul id="js_Notification" class="marquee cf">
            <li>
 
              {{"Important Notice:The UDID Portal will remain temporarily unavailable from 21st May, 2026 to 24th May, 2026 due to migration to the upgraded NGC Cloud Server. During this period, all portal services shall remain suspended temporarily. Inconvenience caused is regretted." |translate }}  
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section> -->
<!-- aobut section -->
<section class="about-section">
  <div class="container-xl">
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <div class="aobut-inner">
          <div class="about-title"> <span>{{"About" |translate}}</span>
            <h2>{{"Unique Disability ID Card" |translate}}</h2>
          </div>
          <p>{{" UDID sub scheme is being implemented with a view of creating a National Database for Persons with
            Disabilities across the country. Under the UDID project, certificates of disability and Unique Disability
            Identity cards are issued to Persons with Disabilities through competent medical authorities notified by
            respective State Governments/Union Territories. The project aims to encourage transparency, efficiency in
            the system of delivering the government benefits to the person with disabilities.."| translate }}</p>
        </div>

      </div>
      <div class="col-md-12 col-lg-6">
        <div class="allticker">
          <div class="container-xl">
            <div class="allticker-inner">
              <div class="row">
                <div class="col-md-12">
                  <div class="latestNewsWrap">
                    <h2 class="cause-listtitle">{{'Important Circulars' | translate}}</h2>
                    <div class="ticker"> <a class="playPause stop newsPlayPause" href="#" title="Pause">{{'Pause' |
                        translate}}</a>
                      <div class="tickerDivBlock">

                        <ul class="activityTicker">
                          <ng-container *ngFor="let item of newsupdate ;let i = index">
                            <li>
                              <div class="gause-list">
                                <div class="gaue-date">
                                  <div class="gause-inner"><a href="javascript:void(0)"><span
                                        class="fa-regular fa-calendar-days"></span> {{item.view_start_date}}</a></div>
                                </div>
                                <p>{{item.news_title}}</p>
                              </div>
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                      <a class="viewall" routerLink="/news-update" title="View All">{{"View All" |translate}} <span
                          class="fa-solid fa-chevron-right"></span></a>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" style="display:none;">
                  <div class="related-list">
                    <h2 class="cause-listtitle">Related Links</h2>
                    <ul>
                      <li>Apply for Disability Certificate & UDID Card</li>
                      <li>Apply for Disability Certificate & UDID Card Renewal</li>
                      <li>Apply for Lost UDID Card</li>
                      <li>Track Your Application Status</li>
                      <li>Download your e-Disability Card & e-UDID Card</li>
                      <li>Update Personal Profile</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- 3 box -->
<section class="objective-section">
  <div class="container-xl">
    <div class="row">
      <div class="col-md-12 col-lg-4">
        <div class="objective-inner">
          <div class="obje-img"><img src="assets/images/objective1.jpg" alt="objective1" loading="lazy"></div>
          <div class="obje-text">
            <div class="obje-title">{{'Objective' | translate}}</div>
            <p>{{'The Objective of this project is to enable the PwDs to obtain the new UDID card / Disability
              Certificate to avail schemes and benefits.' | translate}}</p>
            <button type="button" class="know-more">{{'Know More' | translate}} <span
                class="fa-solid fa-chevron-right"></span></button>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-4">
        <div class="objective-inner">
          <div class="obje-img"><img src="assets/images/objective2.jpg" alt="objective2" loading="lazy"></div>
          <div class="obje-text">
            <div class="obje-title">{{'Registration Open for UDID' | translate}}</div>
            <p><a href="#">{{'Apply Online for UDID Card' | translate}}</a><br />
              {{'Guidelines for Registration' | translate}}</p>
            <button type="button" class="know-more">{{'Know More' | translate}} <span
                class="fa-solid fa-chevron-right"></span></button>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-4">
        <div class="objective-inner">
          <div class="obje-img"><img src="assets/images/objective3.jpg" alt="objective3" loading="lazy"></div>
          <div class="obje-text">
            <div class="obje-title">{{'Procedures/Guidelines' | translate}}</div>
            <p>{{'Procedure and guidelines to apply for UDID can be via online, camps and through CMO offices.' |
              translate}}</p>
            <button type="button" class="know-more">{{'Know More' | translate}} <span
                class="fa-solid fa-chevron-right"></span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- photo video section slider -->
<section class="phvid-section">
  <div class="container-xl">
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <div class="know-authority">
          <div class="titleauthority">{{"Know your Medical Authority" |translate}}</div>
          <div class="indiamap"><img src="assets/images/india-map.png" alt="india-map" loading="lazy"></div>
          <p>{{"To know your medical authority, you need to select your state / UTs and district where you reside. Click
            on below to know your medical authority." |translate}}</p>
          <button routerLink="/findNearestMedicalAutority" type="button" class="find-nearest">{{"Find Nearest Medical
            Autority" |translate}}</button>
        </div>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="mediaGellary-wrap position-relative">
          <div class="mediaLoader">
            <img src="assets/images/loader.svg" alt="Loader">
          </div>
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="photo-tab" data-bs-toggle="tab" data-bs-target="#photo" type="button"
                role="tab" aria-controls="photo" aria-selected="true" title="Photo Gallery">{{"Photo Gallery"|
                translate}}</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="video-tab" data-bs-toggle="tab" data-bs-target="#video" type="button"
                role="tab" aria-controls="video" aria-selected="false" title="Video Gallery">{{"Video Gallery"
                |translate}}</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="photo" role="tabpanel" aria-labelledby="photo-tab">
              <a class="eventsview" routerLink="/photo-gallery" title="View All"> {{"View All" |translate}} <span
                  class="fa-solid fa-chevron-right"></span></a>
              <div class="photoGallery">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <ng-container *ngFor="let item of photos;let i = index">
                      <div class="swiper-slide">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="photo-box">
                              <div class="photo-frem"> <img src="{{PhotosCategoriesPath}}{{item.category_image}}"
                                  alt="{{item.category_name}}" /> </div>
                              <div class="photo-contant">
                                <p>{{item.category_name}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="sliderArrowWrap">
                  <div class="sliderPrev mediaPrev" title="Previous"><span class="chevron-left"></span></div>
                  <div class="sliderNext mediaNext" title="Next"><span class="chevron-right"></span></div>
                  <div class="swiper-button-play" title="play"><a href="#" title="play">play</a></div>
                  <div class="swiper-button-pause" title="stop"><a href="#" title="stop">stop</a></div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="video" role="tabpanel" aria-labelledby="video-tab">
              <a class="eventsview" routerLink="/video-gallery" title="View All">{{"View All" |translate }}<span
                  class="fa-solid fa-chevron-right"></span> </a>
              <div class="mediaGallery">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <ng-container *ngFor="let item of videos;let i = index">
                      <div class="swiper-slide">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="video-box">
                              <div class="video-frem"><img src="{{videoCategoriesPath}}{{item.category_image}}"
                                  alt="{{item.category_name}}" /> </div>
                              <div class="video-contant">
                                <p>{{item.category_name}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="mediaarrow">
                  <div class="sliderPrev mediaPrev" title="Previous"> <span class="chevron-left"></span> </div>
                  <div class="sliderNext mediaNext" title="Next"> <span class="chevron-right"></span> </div>
                  <div class="swiper-button-play" title="play"><a href="#" title="play">play</a></div>
                  <div class="swiper-button-pause" title="stop"><a href="#" title="stop">stop</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-md-12 col-lg-6">
        <div class="mediaGellary-wrap">
          <div class="resTab">
            <ul class="tabNav">
              <li><a href="#tabPhotoGallery" title="Photo Gallery">{{"Photo Gallery"| translate}}</a></li>
              <li><a href="#tabVideoGallery" class="videoClick" title="Video Gallery">{{"Video Gallery" |translate}}</a>
              </li>
            </ul>
            <div class="tabContainer">
              <div id="tabPhotoGallery" class="tabContent">
                <a class="eventsview" routerLink="/photo-gallery" title="View All"> {{"View All" |translate}} <span
                    class="fa-solid fa-chevron-right"></span></a>
                <div class="photoGallery">
                  <div class="swiper-container">
                    <div class="swiper-wrapper">
                      <ng-container *ngFor="let item of photos;let i = index">
                        <div class="swiper-slide">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="photo-box">
                                <div class="photo-frem"> <img src="{{PhotosCategoriesPath}}{{item.category_image}}"
                                    alt="{{item.category_name}}" /> </div>
                                <div class="photo-contant">
                                  <p>{{item.category_name}}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="sliderArrowWrap">
                    <div class="sliderPrev mediaPrev" title="Previous"><span class="chevron-left"></span></div>
                    <div class="sliderNext mediaNext" title="Next"><span class="chevron-right"></span></div>
                    <div class="swiper-button-play" title="play"><a href="#" title="play">play</a></div>
                    <div class="swiper-button-pause" title="stop"><a href="#" title="stop">stop</a></div>
                  </div>
                </div>
              </div>
              <div id="tabVideoGallery" class="tabContent">
                <a class="eventsview" routerLink="/video-gallery" title="View All">{{"View All" |translate }}<span
                    class="fa-solid fa-chevron-right"></span> </a>
                <div class="mediaGallery">
                  <div class="swiper-container">
                    <div class="swiper-wrapper">
                      <ng-container *ngFor="let item of videos;let i = index">
                        <div class="swiper-slide">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="video-box">
                                <div class="video-frem"><img src="{{videoCategoriesPath}}{{item.category_image}}"
                                    alt="{{item.category_name}}" /> </div>
                                <div class="video-contant">
                                  <p>{{item.category_name}}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="mediaarrow">
                    <div class="sliderPrev mediaPrev" title="Previous"> <span class="chevron-left"></span> </div>
                    <div class="sliderNext mediaNext" title="Next"> <span class="chevron-right"></span> </div>
                    <div class="swiper-button-play" title="play"><a href="#" title="play">play</a></div>
                    <div class="swiper-button-pause" title="stop"><a href="#" title="stop">stop</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>     
        </div>
      </div>
    </div> -->
  </div>
</section>